import { observer } from 'mobx-react-lite'
import React from 'react'

// evertel
import { Card, CardBody, Text } from '@evertel/web/ui'
import { Document, WidgetsProvider, normalize } from '@evertel/schema-parser'
import { DocumentServiceProvider } from '@evertel/service'
import { WriteWidgets } from '../schema-widgets'
import { SchemaBuilderController } from '../../controller'


interface SchemaBuilderPreviewProps {
    controller: SchemaBuilderController
}

const SchemaBuilderPreview: React.FC<SchemaBuilderPreviewProps> = observer(({
    controller: schemaBuilderController
}) => {

    const rootSchema = (schemaBuilderController.schema?.layouts) ? normalize(schemaBuilderController.schema) : undefined
    const hasContent = !!rootSchema?.layouts?.full?.some((row: any) => row.items?.length)

    return (
        <Card style={{minHeight: 400}}>
            <CardBody>
                {hasContent ?
                    <DocumentServiceProvider services={[{ id: 'meta', value: { } }]}>
                        <WidgetsProvider value={WriteWidgets}>
                            <Document
                                layout="full"
                                schemaId={schemaBuilderController.id}
                                schema={schemaBuilderController.schema}
                            />
                        </WidgetsProvider>
                    </DocumentServiceProvider>
                    :
                    <div
                        className="d-flex align-items-center justify-content-center text-center h-100"
                        style={{ minHeight: 378 }}>
                        <Text color="muted">
                            There is no content in the template builder yet. <br /> Go to the builder and add elements so you can preview the template here.
                        </Text>
                    </div>
                }
            </CardBody>
        </Card>
    )
})

export { SchemaBuilderPreview }
